export default __webpack_public_path__ + "static/oggimage-5fee79805b06530da5f9e3986d496494.png";